module.exports = __webpack_public_path__ + "static/Aviva-Dolls-House-310562672f684bd4ebbcfbde7a15f49a.png";